import icon from "../../assets/waterdrop.svg";
import type { Property } from "../../types";

export const weatherproofing: Property = {
  id: "weatherproofing",
  title: "weatherproofing.title",
  icon,
};
